import {FacePart} from "../../common";

export default new FacePart({
	render () {
		return `
			<g transform="translate(0.000000, 8.000000)" fill-opacity="0.599999964">
				<circle cx="30" cy="22" r="6"/>
				<circle cx="82" cy="22" r="6"/>
			</g>
		`;
	},
});



// WEBPACK FOOTER //
// ./src/face/eyes/basic.js